﻿(function () {
    'use strict';

    var serviceId = 'datacontext';

    angular
        .module('app.services')
        .factory(serviceId, datacontext);

    datacontext.$inject = ['repositories'];

    function datacontext(repositories) {
        var primePromise;

        var repoNames = [
            'auth',
            'authTokenManager',
            'authorization',
            /*---- All the business repositories below ----*/
            'security',
            'appointment',
            'equipmenttracking',
            'equipmentdamage',
            'eir',
            'trucktracking',
            'progressdepotorder',
            'equipmentstock',
            'containerreception',
            'inspectiontime',
            'stocksummary',
            'servicetime',
            'repairtime',
            'longstanding',
            'gateoperationinventory',
            'oos',
            'dryreefer',
            'servicetimeshipper',
            'useraccountrequest',
            'alertSetting'
        ];

        var service = {
            prime: prime
        };

        init();

        return service;

        function init() {
            defineLazyLoadedRepos();
        }

        function defineLazyLoadedRepos() {
            repoNames.forEach(function (name) {
                Object.defineProperty(service, name, {
                    configurable: true,
                    get: function () {
                        var repo = repositories.getRepo(name);
                        Object.defineProperty(service, name, {
                            value: repo,
                            configurable: false,
                            enumerable: true
                        });
                        return repo;
                    }
                });
            });
        }

        function prime() {
            if (primePromise) return primePromise;
            return primePromise;
        }

    }
})();